export default [
	//商户列表
	{
		path: 'list',
		name: 'm_saas',
		props: route => route.params,
		component: () => import('@/pages/saas/saas_list')
	},
	//商户版本列表
	{
		path: 'version',
		name: 'm_version',
		props: route => route.params,
		component: () => import('@/pages/saas/version_list')
	},
	//账号风险管控列表
	{
		path: 'risk',
		name: 'm_risk',
		props: route => route.params,
		component: () => import('@/pages/saas/risk_list')
	},
	//商户电子货架管理
	{
		path: 'shelf',
		name: 'm_electronic_shelf',
		props: route => route.params,
		component: () => import('@/pages/saas/saas_electronic_shelf_list')
	},
	//商家入驻申请列表
	{
		path: 'apply',
		name: 'm_saas_apply',
		props: route => route.params,
		component: () => import('@/pages/saas/saas_apply_list')
	},
	//超卖订单处理(运营端)
	{
		path: 'oversold',
		name: 'm_ops_oversold_list',
		props: route => route.params,
		component: () => import('@/pages/saas/oversold_list')
	},
	//下架异常处理(运营端)
	{
		path: 'abnormal',
		name: 'm_ops_abnormal_list',
		props: route => route.params,
		component: () => import('@/pages/saas/abnormal_list')
	}
];
